module.exports = __webpack_public_path__ + "static/media/top.dc703b61.svg";